import React, { Component } from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

import { name, storageKeys } from 'settings';
import { BackImage, StorageHandler, LanguageSelect, locales } from 'C4';

import logo from 'assets/images/logo/logo_white.png';


export default class WelcomeView extends Component {
  constructor(props) {
    super(props);

  }

  componentDidMount() {
    const pathname = window.location.pathname;

    i18n.setTexts(locales[pathname]);
    if (pathname === '/fr') {
      StorageHandler.save(storageKeys.lang, { country: 'French', code: 'FR', langFile: 'fr' });
    } else if (pathname === '/it') {
      StorageHandler.save(storageKeys.lang, { country: 'Italian', code: 'IT', langFile: 'it' });
    } else if (pathname === '/de') {
      StorageHandler.save(storageKeys.lang, { country: 'German', code: 'DE', langFile: 'de' });
    } else if (pathname === '/gr') {
      StorageHandler.save(storageKeys.lang, { country: 'German', code: 'DE', langFile: 'de' });
    } else if (pathname === '/uk') {
      StorageHandler.save(storageKeys.lang, { country: 'UK English', code: 'GB', langFile: 'en' });
    } else if (pathname === '/gb') {
      StorageHandler.save(storageKeys.lang, { country: 'UK English', code: 'GB', langFile: 'en' });
    } else {
      StorageHandler.save(storageKeys.lang, { country: 'English', code: 'US', langFile: 'en' });
    }
    window.location.href = "/login";
  }

  render() {

    return (
      <div className="welcomeView">
        <BackImage />
        <div className="welcomeView__Wrapper">
          <img src={logo} alt={name} />
        </div>
      </div>
    );
  }
}
